// This component renders a popover with a list of datasets
// Used in following places
// 	- when a new Playbook button is clicked, this popup will allow to select a dataset to work with in that playbook
// 	- when changing a dataset from within dataviewerbottom component, this list is presented to 'Add Dataset'

import { MenuItem, Popover, TextField, Button, Paper } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { connect } from 'react-redux';
import './Popover.css';
import {
  resetPageSettings,
  setPageSettings,
} from '../../../redux/PageSettings/DownloadPageSettingsActions';
import { Dispatch } from 'redux';
import { orientations, paperSize } from './pageSettingsData';
import { handleKeyDown } from '../CommonFunctions';
import { useState } from 'react';

const DownloadPagePopover = ({
  pageSettings,
  tabTileProps,
  showDash,
  tabState,
  selectedTab,
  //

  setPageSettings,
  resetPageSettings,
}: any) => {
  const textFieldStyleProps = {
    style: {
      fontSize: '12px',
      width: pageSettings.downloadType === 'pdf' ? '150px' : '70%',
      margin: '6px auto 0.5rem 0',
      backgroundColor: 'white',
      height: '1.5rem',
      color: '#404040',
    },
  };

  const resolutionType = tabState.tabs[selectedTab]?.resolutionSettings?.resolutionType;
  const showScrollWarning = showDash && resolutionType !== 'autoFit';
  const downloadFormat = pageSettings.downloadType === 'pdf' ? 'pdf' : 'image';

  const [topMargin, setTopMargin] = useState(pageSettings.top_margin);
  const [bottomMargin, setBottomMargin] = useState(pageSettings.bottom_margin);
  const [leftMargin, setLeftMargin] = useState(pageSettings.left_margin);
  const [rightMargin, setRightMargin] = useState(pageSettings.right_margin);

  return (
    <Popover
      open={pageSettings.openPageSettingPopover}
      onClose={() => {
        setPageSettings('openPageSettingPopover', false);
        setTimeout(() => {
          resetPageSettings();
        }, 300);
      }}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
    >
      <Paper
        sx={{
          width: pageSettings.downloadType === 'pdf' ? '450px' : '450px',
          height: pageSettings.downloadType === 'pdf' ? '300px' : 'auto',
          border: 'none',
          boxShadow: 'none',
        }}
      >
        <div className="datasetListPopover">
          <div className="datasetListPopoverHeading">
            <div style={{ flex: 1, color: 'grey' }}>Page settings</div>

            <CloseRoundedIcon
              style={{ marginLeft: '1rem', color: 'grey' }}
              onClick={() => {
                setPageSettings('openPageSettingPopover', false);
                setTimeout(() => {
                  resetPageSettings();
                }, 300);
              }}
            />
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '50% 50%',
              columnGap: '10px',
              rowGap: '10px',
            }}
          >
            {pageSettings.downloadType === 'pdf' ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Orientation</span>
                  <TextField
                    value={pageSettings.SelectedOrientation}
                    variant="outlined"
                    onChange={(e) => {
                      setPageSettings('SelectedOrientation', e.target.value);
                    }}
                    InputProps={{
                      ...textFieldStyleProps,
                    }}
                    select
                  >
                    {orientations.map((ori: string) => {
                      return (
                        <MenuItem key={ori} value={ori} style={{ textTransform: 'capitalize' }}>
                          {ori}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Format</span>
                  <TextField
                    value={pageSettings.selectedFormat}
                    variant="outlined"
                    onChange={(e) => {
                      setPageSettings('selectedFormat', e.target.value);
                    }}
                    InputProps={{ ...textFieldStyleProps }}
                    select
                  >
                    {paperSize.map((size: string) => {
                      return (
                        <MenuItem key={size} value={size}>
                          {size}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Top margin</span>
                  <TextField
                    type="number"
                    value={topMargin}
                    variant="outlined"
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
                      handleKeyDown(event)
                    }
                    onChange={(e) => {
                      setTopMargin(e.target.value);
                    }}
                    onBlur={() => {
                      setPageSettings('top_margin', Number(topMargin));
                    }}
                    InputProps={{
                      ...textFieldStyleProps,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        padding: '16.5px 14px', // Consistent padding for all browsers
                      },
                      // Firefox-specific styling
                      '@supports (-moz-appearance: none)': {
                        '& .MuiOutlinedInput-input': {
                          padding: '16.5px 2px 16.5px 14px',
                        },
                      },
                    }}
                  ></TextField>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Bottom margin</span>
                  <TextField
                    type="number"
                    value={bottomMargin}
                    variant="outlined"
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
                      handleKeyDown(event)
                    }
                    onChange={(e) => {
                      setBottomMargin(e.target.value);
                    }}
                    onBlur={(e) => {
                      setPageSettings('bottom_margin', Number(bottomMargin));
                    }}
                    InputProps={{
                      ...textFieldStyleProps,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        padding: '16.5px 14px', // Consistent padding for all browsers
                      },
                      // Firefox-specific styling
                      '@supports (-moz-appearance: none)': {
                        '& .MuiOutlinedInput-input': {
                          padding: '16.5px 2px 16.5px 14px',
                        },
                      },
                    }}
                  ></TextField>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Left margin</span>
                  <TextField
                    type="number"
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
                      handleKeyDown(event)
                    }
                    value={leftMargin}
                    variant="outlined"
                    onChange={(e) => {
                      setLeftMargin(e.target.value);
                    }}
                    onBlur={(e) => {
                      setPageSettings('left_margin', Number(leftMargin));
                    }}
                    InputProps={{
                      ...textFieldStyleProps,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        padding: '16.5px 14px', // Consistent padding for all browsers
                      },
                      // Firefox-specific styling
                      '@supports (-moz-appearance: none)': {
                        '& .MuiOutlinedInput-input': {
                          padding: '16.5px 2px 16.5px 14px',
                        },
                      },
                    }}
                  ></TextField>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span style={{ fontSize: '14px' }}>Right margin</span>
                  <TextField
                    type="number"
                    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
                      handleKeyDown(event)
                    }
                    value={rightMargin}
                    variant="outlined"
                    onChange={(e) => {
                      setRightMargin(e.target.value);
                    }}
                    onBlur={(e) => {
                      setPageSettings('right_margin', Number(rightMargin));
                    }}
                    InputProps={{
                      ...textFieldStyleProps,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-input': {
                        padding: '16.5px 14px', // Consistent padding for all browsers
                      },
                      // Firefox-specific styling
                      '@supports (-moz-appearance: none)': {
                        '& .MuiOutlinedInput-input': {
                          padding: '16.5px 2px 16.5px 14px',
                        },
                      },
                    }}
                  ></TextField>
                </div>
              </>
            ) : (
              <>
                {/* <div
								style={{
									display: "flex",
									flexDirection: "column",
								}}
							>
								<span style={{ fontSize: "14px" }}>Height</span>
								<TextField
									value={pageSettings.customHeight}
									variant="outlined"
									type="number"
									onChange={e => {
										setPageSettings("customHeight", Number(e.target.value));
									}}
									InputProps={{ ...textFieldStyleProps }}
								/>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
								}}
							>
								<span style={{ fontSize: "14px" }}>Width</span>
								<TextField
									value={pageSettings.customWidth}
									variant="outlined"
									type="number"
									onChange={e => {
										setPageSettings("customWidth", Number(e.target.value));
									}}
									InputProps={{ ...textFieldStyleProps }}
								/>
							</div> */}
              </>
            )}
          </div>
          {showScrollWarning && (
            <div style={{ marginTop: '15px', paddingTop: '10px', borderTop: '1px solid #eee' }}>
              <p style={{ margin: 0, fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
                The <strong>{downloadFormat}</strong> captures only the visible part of the page and
                any content beyond the scroll will be ignored.
              </p>
            </div>
          )}
          <div>
            <Button
              sx={{
                float: 'right',
                textTransform: 'none',
                backgroundColor: '#2bb9bb',
                color: 'white',
                margin: '10px -3px 10px 10px',
              }}
              onClick={() => {
                setPageSettings('callForDownload', true);
                // setPageSettings('fullScreen', false);
              }}
            >
              {pageSettings.downloadType === 'pdf' ? 'Set & Download' : 'Download'}
            </Button>
          </div>
        </div>
      </Paper>
    </Popover>
  );
};
const mapStateToProps = (state: any, ownProps: any) => {
  return {
    pageSettings: state.pageSettings,
    tabTileProps: state.tabTileProps,
    showDash: state.tabTileProps.showDash,
    tabState: state.tabState,
    selectedTab: state.tabTileProps.selectedTabId,
  };
};
const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setPageSettings: (option: string, value: any) => dispatch(setPageSettings(option, value)),
    resetPageSettings: () => dispatch(resetPageSettings()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPagePopover);
